"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = connectToKiota;
const cp = __importStar(require("child_process"));
const rpc = __importStar(require("vscode-jsonrpc/node"));
const install_1 = require("./install");
async function connectToKiota(callback, workingDirectory = process.cwd()) {
    const kiotaPath = (0, install_1.getKiotaPath)();
    await (0, install_1.ensureKiotaIsPresent)();
    const childProcess = cp.spawn(kiotaPath, ["rpc"], {
        cwd: workingDirectory,
        env: {
            ...process.env,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            KIOTA_CONFIG_PREVIEW: "true",
        }
    });
    const inputReader = new rpc.StreamMessageReader(childProcess.stdout);
    const outputWriter = new rpc.StreamMessageWriter(childProcess.stdin);
    const connection = rpc.createMessageConnection(inputReader, outputWriter);
    connection.listen();
    try {
        return await callback(connection);
    }
    catch (error) {
        console.warn(error);
        const errorMessage = error?.data?.message
            || 'An unknown error occurred';
        return new Error(errorMessage);
    }
    finally {
        inputReader.dispose();
        outputWriter.dispose();
        connection.dispose();
        childProcess.stdin?.end();
        childProcess.kill();
    }
}
//# sourceMappingURL=connect.js.map